import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { GithubService } from '../../service';

export type OldestChangeConfig = typeof OldestChangeConfig._.Config;

export const OldestChangeConfig = IntegrationConfig.make({
  service: GithubService,
  name: Integration_Handler_Names_Enum.OldestChange,
  configSchema: z.object({
    repoName: z.string().min(1),
  }),
});
